module.exports = "/assets/c497437d0e7d2b8abf3921bb0d841e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/S3.png
// module id = 2928
// module chunks = 0